var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconQuotas = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2 17H3.84444C2.84879 17 2.35097 17 1.97068 16.8062C1.63617 16.6358 1.36421 16.3638 1.19377 16.0293C1 15.649 1 15.1512 1 14.1556V3.84444C1 2.8488 1 2.35097 1.19377 1.97068C1.36421 1.63617 1.63617 1.36421 1.97068 1.19377C2.35097 1 2.8488 1 3.84444 1H14.1556C15.1512 1 15.649 1 16.0293 1.19377C16.3638 1.36421 16.6358 1.63617 16.8062 1.97068C17 2.35097 17 2.8488 17 3.84444V6.33333M7.22222 12.5556V8.11111H4.55556V12.5556H7.22222ZM7.22222 12.5556H9.88889V5.44444H7.22222V12.5556ZM15.2222 10.3333C15.2222 11.0697 14.6253 11.6667 13.8889 11.6667C13.1525 11.6667 12.5556 11.0697 12.5556 10.3333C12.5556 9.59695 13.1525 9 13.8889 9C14.6253 9 15.2222 9.59695 15.2222 10.3333ZM14.8298 14.3333H12.948C12.1828 14.3333 11.5034 14.823 11.2615 15.5489L10.7778 17H17L16.5163 15.5489C16.2743 14.823 15.595 14.3333 14.8298 14.3333Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconQuotas);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/iconQuotas.f186ec3294b16ef691ad6061c0e75339.svg";